/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from "react-hook-form";
import Select from "@/components/select";
import { clearErrorsHandler } from "@/components/formBuilder/components/selectInput/helpers";
export default function SelectInputComponent(param) {
    let { placeholder, useOffset, getTitle, fixed, onlyKey, inputClassName, menuClassName, searchable, clearable, className, inputProps, readOnly, options, moreOnChange, defaultValue, disabled, path, label, required } = param;
    // hooks
    const formMethods = useFormContext();
    return /*#__PURE__*/ _jsx(Controller, {
        disabled: disabled,
        rules: {
            required
        },
        defaultValue: defaultValue,
        name: path,
        render: (param)=>{
            let { field: { name, onChange, disabled, ref, value, onBlur }, fieldState: { error } } = param;
            return /*#__PURE__*/ _jsx(Select, {
                placeholder: placeholder,
                useOffset: useOffset,
                getTitle: getTitle,
                fixed: fixed,
                options: options,
                onlyKey: onlyKey,
                inputClassName: inputClassName,
                menuClassName: menuClassName,
                searchable: searchable,
                clearable: clearable,
                className: className,
                inputProps: inputProps,
                readOnly: readOnly,
                onBlur: onBlur,
                label: label,
                id: name,
                value: value,
                disabled: disabled,
                error: !!error,
                onChange: onChange,
                moreOnChange: moreOnChange,
                ref: ref,
                onFocus: ()=>clearErrorsHandler(formMethods, path)
            });
        }
    });
}
